module.exports = __webpack_public_path__ + "static/img/A-android.2f80fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-android.png
// module id = gsN1
// module chunks = 4